import styled from "styled-components";
import { TipoRetorno } from ".";

const CORES: Record<TipoRetorno, { fundo: string; icone: string }> = {
  sucesso: { fundo: "#e6f9f0", icone: "#28a745" },
  aviso: { fundo: "#fff5eb", icone: "#fe8f14" },
  erro: { fundo: "#ffe4e4", icone: "#ee5353" },
};

export const Corpo = styled.div`
  text-align: center;
  padding: 8px 0;
`;

export const Icone = styled.div<{ $tipo: TipoRetorno }>`
  margin: auto;
  margin-bottom: 16px;
  font-size: 42px;

  svg {
    background-color: ${({ $tipo }) => CORES[$tipo].fundo};
    color: ${({ $tipo }) => CORES[$tipo].icone};
    border-radius: 12px;
    padding: 10px;
  }
`;
